import { render, staticRenderFns } from "./EMajor.vue?vue&type=template&id=fa117dc6&scoped=true&"
import script from "./EMajor.vue?vue&type=script&lang=js&"
export * from "./EMajor.vue?vue&type=script&lang=js&"
import style0 from "./EMajor.vue?vue&type=style&index=0&id=fa117dc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa117dc6",
  null
  
)

export default component.exports